export default class Image {
  caption = "";
  image = "";

  constructor(image: string, caption: string) {
    this.image = image;
    this.caption = caption;
  }

  get backgroundImage(): string {
    return `background-image: url('${this.image}');`;
  }
}
